<template>
  <div class="width-100">
    <b-spinner
      style="width: 30px; height: 30px; color: #5445f3"
      v-if="loading"
      label="Large Spinner"
    ></b-spinner>

    <div v-if="!loading">
      <div class="d-flex relative">
        <span class="fa fa-search ico-search"></span>
        <vue-bootstrap-typeahead
          :data="contacts"
          v-model="selectedContactItem"
          ref="refContactName"
          class="diligenceAutoCompleteClass"
          :serializer="checkContact"
          :minMatchingChars="1"
          placeholder="Search Contact"
          @hit="onAfterContactSelection"
        >
          <template slot="suggestion" slot-scope="{ data }">
            <div :class="data && data.duplicate == 'found' ? 'duplicate' : ''">
              {{ data.name }}
              <span class="gray">{{ data.email }}</span>
              <span v-if="data && data.duplicate == 'found'" class="exists">
                already added
              </span>
            </div>
          </template>
        </vue-bootstrap-typeahead>
      </div>

      <div id="scrollWrapper" class="fixed-height-wrapper">
        <table class="fill-list">
          <tr class="header-row">
            <th>Name</th>
            <th>Email</th>
            <th>&nbsp;</th>
          </tr>
          <tbody>
            <tr
              v-for="(item, index) in selectedContacts"
              :key="index"
              class="item-row"
            >
              <td>
                <div class="d-flex label-cover" v-if="item._id">
                  <label :for="index">{{ item.name }}</label>
                </div>

                <input
                  v-if="!item._id"
                  v-model="item.name"
                  class="input-field"
                  :class="errorNameClass(item.name)"
                />
              </td>
              <td class="field-cover">
                <input
                  type="email"
                  v-model="item.email"
                  class="input-field"
                  :class="errorEmailClass(item.email)"
                />
              </td>
              <td class="field-cover text-right">
                <span
                  @click="removeContact(item)"
                  class="fa fa-trash pointer"
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <span class="link" @click="handleAddNew">+ Add New</span>
  </div>
</template>

<script>
import api from "../../../../src/axios_api";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import contacts from "../../../store/modules/contacts";
export default {
  name: "promotion-contact-card",
  components: {
    VueBootstrapTypeahead,
  },
  data() {
    return {
      contacts: [],
      selectedContacts: [],
      selectedContactItem: null,
      loading: true,
      searchQuery: "",
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  props: {
    workspaceId: String,
    getSelectedContacts: Boolean,
    contactsToSkip: Array,
  },
  created() {
    this.getContacts();
  },
  methods: {
    getContacts() {
      this.loading = true;
      api
        .get(`/contacts/${this.workspaceId}`)
        .then((res) => {
          this.contacts = res.data.encrypt.success;
          this.disableSkippedContacts();

          this.loading = false;
          return Promise.resolve(res.data.encrypt.success);
        })
        .catch((err) => {
          this.loading = false;
          return Promise.reject(err);
        });
    },
    disableSkippedContacts() {
      this.contacts.forEach((contact) => {
        if (this.contactsToSkip) {
          const foundContact = this.contactsToSkip.find((skippedContact) => {
            return (
              skippedContact._id === contact._id ||
              (skippedContact.tempId &&
                contact.tempId &&
                skippedContact.tempId === contact.tempId)
            );
          });

          if (foundContact) {
            contact.duplicate = "found";
          }
        }
      });
    },
    handleAddNew() {
      this.selectedContacts.push({
        _id: "",
        tempId: Date.now(),
        name: "",
        email: "",
        sentOn: new Date().toISOString(),
      });

      let objDiv = document.getElementById("scrollWrapper");
      if (objDiv) {
        setTimeout(() => {
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
      }
    },
    checkContact(item) {
      this.contacts.forEach((contact) => {
        let found = this.selectedContacts.filter((selected) => {
          return selected._id === contact._id;
        });

        if (found.length) {
          contact.duplicate = "found";
        }
      });

      return item.name;
    },
    onAfterContactSelection(selectedValue) {
      if (this.selectedContacts && this.selectedContacts.length) {
        let found = this.selectedContacts.find((item) => {
          return (
            item._id === selectedValue._id ||
            (item.tempId &&
              selectedValue.tempId &&
              item.tempId === selectedValue.tempId)
          );
        });

        if (found) {
          return;
        }
      }

      if (this.contactsToSkip && this.contactsToSkip.length) {
        let foundSkipped = this.contactsToSkip.find((item) => {
          return (
            item._id === selectedValue._id ||
            (item.tempId &&
              selectedValue.tempId &&
              item.tempId === selectedValue.tempId)
          );
        });

        if (foundSkipped) {
          return;
        }
      }

      selectedValue.sentOn = new Date().toISOString();
      this.selectedContacts.push(selectedValue);
    },
    removeContact(item) {
      if (!item._id) {
        let index = this.selectedContacts.findIndex((contact) => {
          return contact.tempId === item.tempId;
        });

        if (index !== -1) {
          this.selectedContacts.splice(index, 1);
        }

        if (!this.selectedContacts.length) {
          this.$emit("contactValidity", false);
        }

        return;
      }

      let index = this.selectedContacts.findIndex((contact) => {
        return contact._id === item._id;
      });

      if (index !== -1) {
        this.selectedContacts.splice(index, 1);
      }

      let index2 = this.contacts.findIndex((contact) => {
        return contact._id === item._id;
      });

      if (index2 !== -1) {
        this.contacts[index2].duplicate = "";
      }

      if (!this.selectedContacts.length) {
        this.$emit("contactValidity", false);
      }
    },
    errorEmailClass(email) {
      if (this.emailReg.test(email)) {
        this.$emit("contactValidity", true);
        return "";
      }

      this.$emit("contactValidity", false);
      return "error";
    },
    errorNameClass(name) {
      if (name.trim() === "") {
        this.$emit("contactValidity", false);
        return "error";
      }

      this.$emit("contactValidity", true);
      return "";
    },
  },
  watch: {
    getSelectedContacts: function (newVal, oldVal) {
      this.selectedContacts.forEach((contact) => {
        if (this.emailReg.test(contact.email)) {
        }
      });

      this.$emit("selectedContacts", this.selectedContacts);
    },
  },
};
</script>

<style>
.fill-list {
  width: 100%;
}
.fill-list tr.item-row {
  border-top: 1px solid #00000026;
}
.fill-list .item-row,
.fill-list .header-row th,
.fill-list .header-row {
  text-align: left;
  font-size: 10px;
  line-height: 12px;
  font-family: "custom-helvetica-bold", "roboto";
  letter-spacing: 0px;
  color: #00000080;
  text-transform: uppercase;
  opacity: 1;
  padding-bottom: 8px;
}
.input-field {
  width: 229px;
  height: 30px;
  border: 1px solid #707070;
  border-radius: 4px;
  opacity: 1;
  font: normal normal bold 10px/12px Helvetica Neue;
  letter-spacing: 0px;
  color: #00000080;
}

/* .input-field.error {
  border: 1px solid red;
} */

.label-cover {
  align-items: center;
  justify-content: flex-start;
}
.label-cover label {
  font: normal normal bold 12px/12px Helvetica Neue;
  letter-spacing: 0px;
  color: #00000080 !important;
  text-transform: capitalize;
  opacity: 1;
  margin: 0;
  margin-left: 10px;
}
.field-cover {
  padding: 10px 0;
}

.fixed-height-wrapper {
  max-height: 200px;
  overflow: auto;
  width: 100%;
  margin-top: 15px;
}

.ico-search {
  position: absolute;
  z-index: 9;
  top: 17px;
  left: 7px;
}

.input-group .form-control {
  /* border: 0px solid red !important; */
  padding-left: 40px;
  /* background-color: #f2f2f2; */
}

.input-group .form-control::-webkit-input-placeholder {
  /* Edge */
  color: #999999;
}

.input-group .form-control:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999999;
}

.input-group .form-control::placeholder {
  color: #999999;
}

.vbt-autcomplete-list {
  overflow-y: auto !important;
}

.diligenceAutoCompleteClass {
  min-width: 300px;
}
</style>